import { MutableRefObject, useLayoutEffect, useState } from 'react';

const QUERY_SELECTOR_PATH =
  ':scope ' +
  '> .dependenciesContainer ' +
  '> .MuiCollapse-root ' +
  '> .MuiCollapse-wrapper ' +
  '> .MuiCollapse-wrapperInner ' +
  '> .node-container';

export const useDependenciesResize = (
  nodeRef: MutableRefObject<HTMLDivElement | null>,
  dependenciesRef: MutableRefObject<HTMLDivElement | null>,
) => {
  const [dependenciesContainerHeight, setDependenciesContainerHeight] = useState<number>(0);

  useLayoutEffect(() => {
    if (!nodeRef.current || !dependenciesRef.current) {
      return;
    }

    const handleResize = () => {
      if (!dependenciesRef.current || !nodeRef.current) {
        return;
      }

      const wrapperHeight = dependenciesRef.current.getBoundingClientRect().height;
      const liElementsInFirstTree = nodeRef.current.querySelectorAll(QUERY_SELECTOR_PATH);

      if (liElementsInFirstTree.length > 0) {
        const lastElementDependenciesContainer =
          liElementsInFirstTree[liElementsInFirstTree.length - 1]?.querySelector('.dependenciesContainer');
        if (lastElementDependenciesContainer) {
          const lastElementHeight = lastElementDependenciesContainer.getBoundingClientRect().height;
          const calculatedHeight = wrapperHeight - lastElementHeight;
          setDependenciesContainerHeight(calculatedHeight);
        } else {
          setDependenciesContainerHeight(wrapperHeight);
        }
      } else {
        setDependenciesContainerHeight(wrapperHeight);
      }
    };

    const observer = new ResizeObserver(handleResize);
    observer.observe(nodeRef.current);

    handleResize();

    return () => observer.disconnect();
  }, [dependenciesRef, nodeRef]);

  return { dependenciesContainerHeight };
};
